<template>
  <div>
    <div v-if="$route.path.indexOf('_content') === -1">
      <el-row :gutter="10" class="mb10">
        <el-select class="input-m" v-model="params.service_type" placeholder="服务类型" clearable @change="searchList">
          <el-option
            v-for="item in serviceTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="!item.configurable">
          </el-option>
        </el-select>
        <el-select class="input-m" v-model="params.enabled" placeholder="启用状态" clearable @change="searchList">
          <el-option label="已启用" :value="1"></el-option>
          <el-option label="已关闭" :value="0"></el-option>
        </el-select>
        <el-button type="primary" icon="plus" size="mini" @click="handleEditScene()">添加服务场景</el-button>
      </el-row>

      <el-table :data="list" :height="wheight - 260" v-loading="loading" style="width: 100%">
        <el-table-column prop="seq_no" label="序号" width="70"></el-table-column>
        <el-table-column prop="scene_name" label="服务场景" min-width="160"></el-table-column>
        <el-table-column prop="service_type_label" label="服务类型" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.service_type_label || '不限制' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="product_mp_title" label="服务产品小程序标题" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="content_mp_title" label="服务内容小程序标题" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="内容多选" width="90">
          <template slot-scope="scope">
            <span>{{ scope.row.allow_multi_content == 1 ? '支持多选' : '仅单选' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="启用" width="90">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.enabled"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
              @change="changeSceneEnabled(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="220">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEditScene(scope.row)">编辑</el-button>
            <el-button type="text" @click="goSceneContent(scope.row)">服务内容</el-button>
            <el-button type="text" @click="copyScene(scope.row)">复制</el-button>
            <el-button type="text" @click="exportScene(scope.row)">导出</el-button>
            <el-button type="text" style="color: red" @click="deleteScene(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="content-padded content-center">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page.sync="params.page"
          :total="total_count"
          :page-size="params.pageSize">
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="sceneForm.id ? '编辑服务场景' : '添加服务场景'" :visible.sync="sceneDialogVisible" width="480px">
      <el-form :model="sceneForm" label-width="120px" ref="sceneForm">
        <el-form-item label="场景名称" prop="scene_name">
          <el-input v-model="sceneForm.scene_name" class="input-b"></el-input>
        </el-form-item>
        <el-form-item label="服务类型" prop="service_type">
          <el-select
            v-model="sceneForm.service_type"
            placeholder="不设置则不限制"
            class="input-b"
            clearable>
            <el-option
              v-for="item in configurableTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品小程序标题" prop="product_mp_title">
          <el-input v-model="sceneForm.product_mp_title" class="input-b" maxlength="50" placeholder="小程序产品区标题"></el-input>
        </el-form-item>
        <el-form-item label="内容小程序标题" prop="content_mp_title">
          <el-input v-model="sceneForm.content_mp_title" class="input-b" maxlength="50" placeholder="小程序内容区标题"></el-input>
        </el-form-item>
        <el-form-item label="服务内容多选">
          <el-radio-group v-model="sceneForm.allow_multi_content">
            <el-radio :label="1">支持多选</el-radio>
            <el-radio :label="0">仅单选</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-switch
            v-model="sceneForm.enabled"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="0">
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sceneDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="sceneSubmitLoading" @click="submitSceneForm">确 定</el-button>
      </span>
    </el-dialog>

    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  getServiceTypeOptions,
  getServiceSceneList,
  createServiceScene,
  updateServiceScene,
  toggleServiceSceneEnabled,
  deleteServiceScene,
  copyServiceScene,
  exportServiceSceneItems
} from '@/api/serviceManagement'

export default {
  data() {
    return {
      loading: false,
      sceneDialogVisible: false,
      sceneSubmitLoading: false,
      exportLoading: false,
      list: [],
      total_count: 0,
      serviceTypeOptions: [],
      params: {
        page: 1,
        pageSize: 20,
        service_type: '',
        enabled: ''
      },
      sceneForm: {
        id: 0,
        scene_name: '',
        service_type: '',
        product_mp_title: '',
        content_mp_title: '',
        allow_multi_content: 1,
        enabled: 1
      }
    }
  },
  computed: {
    ...mapGetters(['wheight']),
    configurableTypeOptions() {
      return this.serviceTypeOptions.filter(item => item.configurable)
    }
  },
  methods: {
    searchList() {
      this.params.page = 1
      this.getSceneList()
    },
    handleCurrentChange(page) {
      this.params.page = page
      this.getSceneList()
    },
    getServiceTypeOptionList() {
      getServiceTypeOptions().then(response => {
        this.serviceTypeOptions = response.data.data.list || []
      })
    },
    getSceneList() {
      this.loading = true
      getServiceSceneList(this.params).then(response => {
        const list = response.data.data.list || []
        // PDO/JSON 常把 smallint 变成字符串，el-switch 的 active-value 为数字时需严格相等
        this.list = list.map(item => ({
          ...item,
          enabled: Number(item.enabled),
          allow_multi_content: Number(item.allow_multi_content == null ? 1 : item.allow_multi_content)
        }))
        this.total_count = Number(response.data.data.total_count || 0)
        this.loading = false
      }).catch(() => {
        this.list = []
        this.total_count = 0
        this.loading = false
      })
    },
    handleEditScene(row) {
      this.sceneDialogVisible = true
      this.$nextTick(() => {
        if (row) {
          this.sceneForm = {
            id: row.id,
            scene_name: row.scene_name,
            service_type: row.service_type,
            product_mp_title: row.product_mp_title || '',
            content_mp_title: row.content_mp_title || '',
            allow_multi_content: Number(row.allow_multi_content == null ? 1 : row.allow_multi_content),
            enabled: Number(row.enabled)
          }
        } else {
          this.sceneForm = {
            id: 0,
            scene_name: '',
            service_type: '',
            product_mp_title: '',
            content_mp_title: '',
            allow_multi_content: 1,
            enabled: 1
          }
        }
      })
    },
    submitSceneForm() {
      if (!this.sceneForm.scene_name) {
        this.$message.warning('请输入服务场景名称')
        return
      }
      this.sceneForm.service_type = this.sceneForm.service_type || ''
      if (!String(this.sceneForm.product_mp_title || '').trim()) {
        this.$message.warning('请填写服务产品小程序标题')
        return
      }
      if (!String(this.sceneForm.content_mp_title || '').trim()) {
        this.$message.warning('请填写服务内容小程序标题')
        return
      }
      this.sceneForm.product_mp_title = String(this.sceneForm.product_mp_title || '').trim()
      this.sceneForm.content_mp_title = String(this.sceneForm.content_mp_title || '').trim()
      this.sceneSubmitLoading = true
      const request = this.sceneForm.id
        ? updateServiceScene(this.sceneForm)
        : createServiceScene(this.sceneForm)
      request.then(response => {
        if (response.data.data.success) {
          this.$message.success(this.sceneForm.id ? '更新成功' : '添加成功')
          this.sceneDialogVisible = false
          this.getSceneList()
        }
        this.sceneSubmitLoading = false
      }).catch(() => {
        this.sceneSubmitLoading = false
      })
    },
    changeSceneEnabled(row) {
      toggleServiceSceneEnabled({
        id: row.id,
        enabled: row.enabled
      }).then(response => {
        if (response.data.data.success) {
          this.$message.success('状态更新成功')
        } else {
          row.enabled = row.enabled == 1 ? 0 : 1
        }
      }).catch(() => {
        row.enabled = row.enabled == 1 ? 0 : 1
      })
    },
    deleteScene(row) {
      this.$confirm('删除后不可恢复，确认删除该服务场景？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteServiceScene({ id: row.id }).then(response => {
          if (response.data.data.success) {
            this.$message.success('删除成功')
            this.getSceneList()
          }
        })
      }).catch(() => {})
    },
    copyScene(row) {
      this.$confirm(`确认复制场景「${row.scene_name}」？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        copyServiceScene({ id: row.id }).then(response => {
          if (response.data.data.success) {
            this.$message.success('复制成功')
            this.getSceneList()
          }
        })
      }).catch(() => {})
    },
    goSceneContent(row) {
      this.$router.push({ path: `${this.matchHidePage('content')}/${row.id}` })
    },
    exportScene(row) {
      if (this.exportLoading) return
      this.exportLoading = true
      exportServiceSceneItems({ scene_id: row.id }).then(response => {
        const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `${row.scene_name}_服务数据_${row.id}.csv`
        link.click()
        window.URL.revokeObjectURL(url)
        this.exportLoading = false
      }).catch(() => {
        this.$message.error('导出失败')
        this.exportLoading = false
      })
    }
  },
  mounted() {
    this.getServiceTypeOptionList()
    this.getSceneList()
  },
  watch: {
    '$route'() {
      if (this.$route.path.indexOf('_content') === -1) {
        this.getSceneList()
      }
    }
  }
}
</script>
